import React from "react";
import { Card, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

const AuthLayout = ({ children }) => {
  return (
    <div className="vh-100 bg-white flex-center">
      <Card className="shadow-lg flex-row align-items-center rounded-5">
        <div className="p-24 border-end" style={{ width: "446px" }}>
          {children}
        </div>

        <div
          className="d-flex p-12 align-items-center ratio-1"
          style={{ minWidth: "356px" }}
        >
          <Image
            className="object-fit-cover mx-auto"
            src="/assets/logo.png"
            alt="logo"
            width={201}
            height={136}
          />
        </div>
      </Card>
      <footer className="fixed-bottom p-12 text-center">
        © {new Date().getFullYear()}, 
        <Link to={"#"} className="text-decoration-none">
          AIM Technologies.
        </Link>
         All Rights Reserved.
      </footer>
    </div>
  );
};

export default AuthLayout;
